import { render } from "./GuideTour.vue?vue&type=template&id=456431f6"
import script from "./GuideTour.vue?vue&type=script&lang=js"
export * from "./GuideTour.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__